module.exports = __webpack_public_path__ + "img/sidenav-item-permission-settings.136325a2.svg";